<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
    name: 'App',
    created() {
      let href = window.location.href
      let index = href.lastIndexOf("\/");
      href = href.substring(index+1,href.length)
      if(href != 'appDownload'){
        let name = this.$route.path.replace("/", "")
        this.$router.replace({path: '/' + encodeURIComponent(name)})
      }     
    }
}
</script>

<style lang='stylus'>
body
  margin 0
</style>



// WEBPACK FOOTER //
// src/App.vue